import Header from "../components/Header";
import Banner from "../components/Banner.vue";
import Title from "../components/Title";
import Content from "../components/Content";
import Thumbs from "../components/Thumbs";
import File from "../components/File";
import Comment from "../components/Comment";
import CommentList from "../components/CommentList";
// import Pager from "../components/Pager";
import { URLS, $subscriber, interact } from "fire-wind-water";
import service from "../services/article";
import template from "../mixin/template";
import { articleId, browerType } from "../common/sbase";
import { articleSettingInfo } from "../common/settingData";

export default {
  name: "Article",
  mixins: [template],
  data() {
    return {
      isShowFile: false,
      isShowComment: false,
      title: "",
      isSetting: false,
      theme: "",
      articleInfo: {},
      globalUserId: "",
      sess: "",
      userInfo: ""
    };
  },
  created() {
    if (URLS.getURL("isSetting")) {
      debugger;
      this.isSetting = true;
      this.isShowFile = true;
      this.isShowComment = true;
      $subscriber.emit("article-info", articleSettingInfo);
      return;
    } else {
      window.$sk.loading.show("正在读取数据");
      window.$sk.template.module(this);
    }
  },
  methods: {
    skUserInit() {
      console.log("获取用户本地信息");
    },
    skUserEnd() {
      console.log("获取用户信息结束");
      const info = window.$sk.template.get();
      this.userInfo = window.$sk.template.get();
      console.log(info);
      this.schemaId = info.common.schemaId;
      //      this.instanceId = info.common.instanceId;
      this.tenantId = info.common.tenantId;
      this.sess = info.user.session;
      this.globalUserId = info.user.globalUserId;
      $subscriber.emit("user-info", info.user);
      //      this.contactInfo = info.user;
      //      this.moduleId = info.common.moduleId;
      //      this.getData();
      this.initConfig(URLS.getURL("configId"), this.tenantId);
      this.load();
    },
    skUserChange() {
      console.log("用户信息发生改变");
    },
    skLinkEnd(e) {
      console.log("跳转逻辑判断完毕");
      if (!e.isJump) {
        $subscriber.emit("article-info", this.articleInfo);
        if (
          ((parseInt(this.articleInfo.bindWeChatId) &&
            this.articleInfo.isCertified == "1" &&
            this.articleInfo.accountType == "1") ||
            (parseInt(this.articleInfo.authorisedWeChatId) &&
              this.articleInfo.authorisedType == 1)) &&
          interact.isWeChat &&
          (!this.userInfo.user.tokenInfo ||
            !this.userInfo.user.tokenInfo.nickname)
        ) {
          //显授权并且没有nickName
          window.$sk.template.update({
            type: "auth",
            data: {
              weChatId:
                parseInt(this.articleInfo.bindWeChatId) ||
                this.articleInfo.authorisedWeChatId,
              scope:
                this.articleInfo.authorisedType == 1
                  ? "snsapi_userinfo"
                  : "snsapi_base"
            }
          });
        } else {
          if (this.checkDevice()) {
            this.browse();
            this.initWeChatShare();
            if (
              this.articleInfo.useLinkUrl == "1" &&
              this.articleInfo.content == ""
            ) {
              window.location.href = this.articleInfo.linkUrl;
              return;
            } else {
              window.$sk.loading.hide();
            }
          }
        }
      }
    },
    initWeChatShare() {
      if (!interact.isWeChat) {
        return;
      }
      const info = this.articleInfo;
      const shareInfo = {
        title: info.shareTitle || info.title, // 分享标题,
        desc: info.shareDesc || info.summary, // 分享描述,
        link: info.longUrlLink || info.url,
        imgUrl: info.shareImageRealPath
          ? "https:" + info.shareImageRealPath
          : "" // 分享图标
      };
      window.$swxsdk.initWxSdk(
        { tenantId: info.tenantId },
        window.$sk.config.apiUrl
      );
      window.$swxsdk.on("sharer", shareInfo);
      window.$swxsdk.on("sharer_friends", shareInfo);
    },
    skAuthEnd(e) {
      this.userInfo.user.tokenInfo = e.tokenInfo;
      this.userInfo.user.openId = e.tokenInfo.original.openid;
      this.initWeChatShare();
      this.browse();
      if (
        this.articleInfo.useLinkUrl == "1" &&
        this.articleInfo.content == ""
      ) {
        window.location.href = this.articleInfo.linkUrl;
        return;
      } else {
        window.$sk.loading.hide();
      }
    },
    load() {
      const param = {
        articleId: articleId,
        tenantId: this.tenantId,
        isScroll: 1,
        withStat: 1,
        withTag: 1
      };
      //获取文章信息
      service.getArticle(param).subscribe(data => {
        this.title = data.content.title + "";
        this.articleInfo = data.content;
        this.isShowComment = data.content.isAllowedComment == 1;
        this.articleInfo.bindWeChatId = "0";
        this.isShowFile =
          data.content.fileIds && data.content.fileIds.length > 0;

        //微信授权这里有点逻辑
        //1 wechatId 不为0的时候是实例下的微信号
        //2 attachWXAccount 没用
        //3 authorisedType 1 显授权   authorisedWeChatId 授权的微信号 是服务号
        //4 wehcatId 优先级高于 authorisedWeChatId
        //5 wechatId不为0是的时候 需要调用接口获取里绑定的wechatId是用来授权的（有订阅号绑定的情况，如果wechatId是服务号 则wechatId和绑定的wechatId是一致的）
        if (this.articleInfo.weChatId && this.articleInfo.weChatId != "0") {
          service
            .getAppId({
              weChatId: this.articleInfo.weChatId,
              wechatId: this.articleInfo.weChatId
            })
            .subscribe(data => {
              this.articleInfo.bindWeChatId = data.content.weChatId; //获取用来授权的微信号
              window.$sk.template.update({
                type: "link",
                data: {
                  identity: this.articleInfo.identity,
                  weChatId: "",
                  skObjectType: "article",
                  skObjectId: this.articleInfo.articleId,
                  meetingInstanceId: this.articleInfo.instanceId,
                  meetingType: 0,
                  memberFormId: this.articleInfo.registerFormId
                }
              });
            });
        } else {
          window.$sk.template.update({
            type: "link",
            data: {
              identity: this.articleInfo.identity,
              weChatId: this.articleInfo.weChatId,
              skObjectType: "article",
              skObjectId: this.articleInfo.articleId,
              meetingInstanceId: this.articleInfo.instanceId,
              meetingType: 0,
              memberFormId: this.articleInfo.registerFormId
            }
          });
        }
        //        this.initWeChatShare();
        //        if (data.content.identity == 3 && sess == "") {
        //          const param = {
        //            formId: data.content.registerFormId,
        //            memberFormId:data.content.registerFormId,
        //            globalUserId: globalUserId,
        //            keyword: "",
        //            num: 999,
        //            schemaId: data.content.schemaId,
        //            start: 0,
        //            tenantId: data.content.tenantId,
        //            trackId: "0"
        //          };
        //          service.getNewForm(param).subscribe(data1 => {
        //            window.location.href = `${
        //              data1.content.pcSourceUrl
        //            }&backUrl=${encodeURIComponent(window.location.href)}`;
        //          });
        //        } else {
        //          this.isShowFile = data.content.fileIds && data.content.fileIds.length > 0;
        //          this.isShowComment = data.content.isAllowedComment == 1;
        //          $subscriber.emit("article-info", data.content);
        //          // window.$s_temp.loading.hide();
        //          // let style = $('<link rel="stylesheet" type="text/css" href="./assets/css/red.css"/>');
        //          // $('head').append(style);
        //          //增加浏览量
        //          if(globalUserId){
        //            let param = {
        //              articleId: articleId,
        //              sess: sess,
        //              globalUserId: globalUserId,
        //              openId: "",
        //              url: window.location.href,
        //              referenceUrl: document.referrer,
        //              equipment: {},
        //              pageTitle: data.content.title,
        //              weChatId: data.content.authorisedWeChatId,
        //              resolution: window.screen.width + "*" + window.screen.height
        //            };
        //            service.browse(param).subscribe(data => {
        //              data;
        //            });
        //          }else{
        //            $subscriber.subscribe('globalUserId-loaded',id=>{
        //              let param = {
        //                articleId: articleId,
        //                sess: sess,
        //                globalUserId: id,
        //                openId: "",
        //                url: window.location.href,
        //                referenceUrl: document.referrer,
        //                equipment: {},
        //                pageTitle: data.content.title,
        //                weChatId: data.content.authorisedWeChatId,
        //                resolution: window.screen.width + "*" + window.screen.height
        //              };
        //              service.browse(param).subscribe(data => {
        //                data;
        //              });
        //            });
        //          }
        //          if (Number(data.content.useLinkUrl) === 1) {
        //            location.replace(data.content.linkUrl);
        //          }else
        //          {
        //            window.$s_temp.loading.hide();//隐藏loading
        //          }
        //
        //        }
      });
    },

    checkDevice() {
      //如果是多栏目需要获取当前目录信息再跳转
      if (window.location.href.indexOf("local") > 0) {
        return true;
      }
      if (browerType == "pc" && location.href.indexOf("wap") > 0) {
        // window.$sk.goto(this.articleInfo.PCUrl);
        // return false;
      }
      if (browerType == "mobile" && location.href.indexOf("wap") < 0) {
        // window.$sk.goto(this.articleInfo.url);
        // return false;
      }
      return true;
    },
    browse() {
      let param = {
        articleId: articleId,
        sess: this.sess,
        globalUserId: this.globalUserId,
        openId: this.userInfo.user.openId || "",
        url: window.location.href,
        referenceUrl: document.referrer,
        equipment: {},
        pageTitle: this.articleInfo.title,
        weChatId: this.articleInfo.authorisedWeChatId,
        resolution: window.screen.width + "*" + window.screen.height
      };
      service.browse(param).subscribe(data => {
        data;
        if (
          this.articleInfo.useLinkUrl == "1" &&
          this.articleInfo.content == ""
        ) {
          window.location.replace(this.articleInfo.linkUrl);
          return;
        }
      });
    }
  },
  components: {
    Header,
    Title,
    Content,
    File,
    Comment,
    CommentList,
    Banner,
    Thumbs
    // Subtitle
  }
};
